import { LoadingOutlined } from "@ant-design/icons";

const Loading = () => (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

export default Loading;
